import React, { Fragment, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { interceptor } from "utils/interceptor";

import { TrangChu } from "../../component/TrangChu";
import { DangNhap } from "../../component/DangNhap";
import { ThemMoiDatHang } from "../../component/DatHang/ThemMoiDatHang";
import { ThemMoiDatHangNgoai } from "../../component/DatHang/ThemMoiDatHangNgoai";
import { DanhSachDonDatHang } from "../../component/DatHang/DanhSachDatHang";
import { PrintDanhSachDonDatHangRp } from "../../component/DatHang/DanhSachDatHang/Print/InDanhSach/PrintDanhSachDonHangRp";
import { PrintListDonHangRp } from "../../component/DatHang/DanhSachDonHang/Print/InDanhSach/PrintListDonHangRp";
import { DanhSachDonHang } from "../../component/DatHang/DanhSachDonHang";
import { MKNguoiDung } from "../../component/HeThong/MKNguoiDung";
import { RpDatHangDaiLy } from "../../component/PrintsFile/rpDatHangDaiLy";
import { RpDatHangDaiLyNgoai } from "../../component/PrintsFile/rpDatHangDaiLyNgoai";
import { RpDonHang } from "../../component/PrintsFile/rpDonHang";
import { PrintDonGuiDatHang } from "../../component/DatHang/DanhSachDatHang/Print/PrintDonGuiDatHang";
import DatHangDaiLy from "../../component/DanhSachDatHang";
import { DoiMatKhau } from "../../component/DanhSachDatHang/DoiMatKhau";
import { PrintDanhSachDonDatHang } from "../../component/DanhSachDatHang/DonDatHang/Print/PrintDanhSachDonDatHang";
import { PrintDanhSachBaoGia } from "../../component/DanhSachDatHang/BaoGiaDaiLy/Print/PrintDanhSachBaoGia";
import { RpDatHangDaiLyVer2 } from "../../component/PrintsFile/rpDatHangDaiLyVer2";
import { RpDatHangDaiLyNgoaiVer2 } from "../../component/PrintsFile/rpDatHangDaiLyNgoaiVer2";
import { RpDonHangVer2 } from "../../component/PrintsFile/rpDonHangVer2";
export default function App() {
  interceptor();

  useEffect(() => {
    // Hàm lắng nghe sự kiện bàn phím
    const handleKeyPress = (event) => {
      // Thêm sự kiện lắng nghe bàn phím
      window.addEventListener("keydown", handleKeyPress);

      // Dọn dẹp sự kiện khi component bị hủy
      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    };
  }, []);

  return (
    <Fragment>
      <Switch>
        <Route exact path="/" component={TrangChu} />
        <Route exact path="/DangNhap" component={DangNhap} />
        <Route exact path="/DatHang" component={ThemMoiDatHang} />
        <Route exact path="/DatHangNgoai" component={ThemMoiDatHangNgoai} />
        <Route exact path="/Users/MKNguoiDung" component={MKNguoiDung} />
        <Route exact path="/DanhSachDatHang" component={DanhSachDonDatHang} />
        <Route
          exact
          path="/PrintsFile/ListDonDatHangRp"
          component={PrintDanhSachDonDatHangRp}
        />
        <Route
          exact
          path="/PrintsFile/ListDonHang"
          component={PrintListDonHangRp}
        />
        <Route exact path="/DanhSachDonHang" component={DanhSachDonHang} />
        <Route exact path="/Users/MKNguoiDung" component={MKNguoiDung} />
        <Route
          exact
          path="/PrintsFile/rpDatHangDaiLy"
          component={RpDatHangDaiLy}
        />
        <Route exact path="/PrintsFile/rpDonHang" component={RpDonHang} />
        <Route
          exact
          path="/PrintsFile/rpDatHangDaiLyNgoai"
          component={RpDatHangDaiLyNgoai}
        />
        <Route
          exact
          path="/PrintsFile/rpDonGuiDatHang"
          component={PrintDonGuiDatHang}
        />
        <Route exact path="/DatHangDaiLy" component={DatHangDaiLy} />
        <Route exact path="/Users/DoiMatKhau" component={DoiMatKhau} />
        <Route
          exact
          path="/PrintsFile/InDanhSach"
          component={PrintDanhSachDonDatHang}
        />
        <Route
          exact
          path="/PrintsFile/InDanhSachBaoGia"
          component={PrintDanhSachBaoGia}
        />

        <Route
          exact
          path="/PrintsFile/rpDatHangDaiLyVer2"
          component={RpDatHangDaiLyVer2}
        />
        <Route
          exact
          path="/PrintsFile/rpDatHangDaiLyNgoaiVer2"
          component={RpDatHangDaiLyNgoaiVer2}
        />
        <Route
          exact
          path="/PrintsFile/rpDonHangVer2"
          component={RpDonHangVer2}
        />
      </Switch>
    </Fragment>
  );
}
